module.exports = __webpack_public_path__ + "static/media/HireRectangle.9b9fb8e6.svg";